// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1y6Mz","content":"LoadingAlert_content__3qB3T"};